import { t } from '@lingui/macro';
import { Alert } from '@pocketlaw/tetris';
export function ExpiredProviderAlert() {
    return (<Alert appearance="info" message={t({
            message: "Since you haven't used e-signing in more than 30 days you need to authenticate.",
            comment: 'Message for when the e-signing provider connection has expired and the user needs to reconnect',
        })}/>);
}
